import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import {
  Center,
  MantineColorScheme,
  SegmentedControl,
  useMantineColorScheme,
} from '@mantine/core';

import styles from './theme-switcher.module.scss';

export const ThemeSwitcher = () => {
  const { setColorScheme } = useMantineColorScheme();

  return (
    <SegmentedControl
      className={styles.switcher}
      onChange={(value) => setColorScheme(value as MantineColorScheme)}
      data={[
        {
          value: 'light',
          label: (
            <Center style={{ gap: 10 }}>
              <SunIcon width={20} />
              <span>Светлый</span>
            </Center>
          ),
        },
        {
          value: 'dark',
          label: (
            <Center style={{ gap: 10 }}>
              <MoonIcon width={20} />
              <span>Тёмный</span>
            </Center>
          ),
        },
      ]}
    />
  );
};
